// object > Actions > Create Alert

(function() {
    'use strict';

    var CallListCtrl = function($scope, ajaxCall, xmsNotificationFactory, $uibModalInstance, passedModel, $http, $compile, $window, $sce) {

        // Begin For Time Based Alert
        console.log("CallListCtrl - TimeBasedAlertCtrl");

        $scope.showSuccessMsg = false;
        $scope.ngModel = {};

        $scope.fnSaveAlert = function($event) {
            $event.preventDefault();

            var ajaxUrl = WEBAPP_PATH + "/timeBasedAlert/saveAlert?";
            var data    = $scope.ngModel;

            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    //xmsNotificationFactory.addObj( {id: 'timeBasedAlertSuccess', type: 'success', bodyHtml: result.data});
                    // console.log("result.data" + result.data);
                    //$uibModalInstance.close($scope.ngModel); // returnValue - the results will be passed back to xms-modal ng-model (passedModel)
                    /* Show the status message  on the screen */
                    $scope.showSuccessMsg = true;

                    $event.preventDefault(); // we may not need this one?
                },
                function(result) {
                    //xmsNotificationFactory.addObj( {id: 'timeBasedAlertSuccess', type: 'danger', bodyHtml: result.data});
                }
            );
        }


        $scope.cancel = function(e) {
            if(angular.isDefined(e)){
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        }
        // End For Time Based Alert


        // Begin For List Tag

        console.log("CallListCtrl - ListTagCtrl");

        $scope.listTabModel = {};
        $scope.listTabModel.errorMessage     = false;
        $scope.listTabModel.showLoader       = false;
        $scope.listTabModel.disableAddBtn    = false;
        $scope.listTabModel.disableRemoveBtn = false;

        $scope.pageLoaded = false;

        $scope.onloadPop = function() {
            if ($scope.pageLoaded != true) {
                $scope.listTabModel.showLoader = true;
                $scope.pageLoaded = true;

                var idList            = $scope.listTabModel.idList;
                var listTagObjectType = $scope.listTabModel.listTagObjectType;
                var mode              = $scope.listTabModel.mode;
                var linkedObjectType  = $scope.listTabModel.linkedObjectType;

                if($scope.listTabModel.allListPage == 'true'){
                    var sic     = $scope.listTabModel.searchInputCookie;
                    var data    = 'sic=' + parseInt(sic) + '&objectType=' + listTagObjectType + '&mode=' + mode + '&forCallList=true';
                    var ajaxUrl = WEBAPP_PATH + "/listTag/listTagAllSaveAjax";

                    ajaxCallList(ajaxUrl , data);
                } else if (idList != null && idList.length != 0) {
                    var data    = 'idList=' + idList + '&objectType=' + listTagObjectType + '&mode=' + mode + '&linkedObjectType=' + linkedObjectType + '&forCallList=true';
                    var ajaxUrl = WEBAPP_PATH + "/listTag/listTagSelectedSaveAjax";

                    ajaxCallList(ajaxUrl , data);
                } else {
                    $scope.listTabModel.errorMessage = true;
                }
            }
        }

//        $scope.cancel = function() {
//            $uibModalInstance.dismiss('cancel');
//        };

        $scope.reloadObjectTags = function(){
            var listTabModel = $scope.listTabModel;
            var data    = 'idList=' +listTabModel.idList + '&objectType=' + listTabModel.listTagObjectType + '&mode=' + listTabModel.mode + '&linkedObjectType=' + listTabModel.linkedObjectType + '&forCallList=true';
            var ajaxUrl = WEBAPP_PATH + "/listTag/listTagSelectedSaveAjax";
            $scope.divTags = "";
            $scope.listTabModel.showLoader       = true;
            ajaxCallList(ajaxUrl , data);
        }

        var ajaxCallList = function(ajaxUrl, data) {
            var errorMsg = 'Error';
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.listTabModel.showLoader       = false;
                    $scope.listTabModel.disableAddBtn    = false;
                    $scope.listTabModel.disableRemoveBtn = false;
                    $scope.divTags                       = $sce.trustAsHtml(result.data);
                },
                function(result) {
                    $scope.listTabModel.showLoader       = false;
                    $scope.listTabModel.disableAddBtn    = false;
                    $scope.listTabModel.disableRemoveBtn = false;
                    $scope.divTags                       = $sce.trustAsHtml(errorMsg);
                }
            );
        }

        $scope.fnAddExistingListTagNg = function($event) {
            $event.preventDefault();

            $scope.listTabModel.showLoader    = true;
            $scope.listTabModel.disableAddBtn = true;
            $scope.divTags = "";
            var existingTag       = $scope.listTabModel.existingTag;
            var processing        = $scope.listTabModel.processing;
            var idList            = $scope.listTabModel.idList;
            var listTagObjectType = $scope.listTabModel.listTagObjectType;
            var linkedObjectType = $scope.listTabModel.linkedObjectType;

            if (processing == '0' && existingTag) {
                $scope.listTabModel.processing = 1;
                var data = 'idList=' + idList + '&objectType=' + listTagObjectType + '&linkedObjectType=' + linkedObjectType + '&forCallList=true';
                data = data + '&existingTag=' + existingTag;
                var ajaxUrl = WEBAPP_PATH + "/listTag/appendListTag";
                ajaxCallList(ajaxUrl , data);
            }
            return false;
        }

        $scope.fnAddListTagNg = function($event) {
            $event.preventDefault();

            $scope.listTabModel.showLoader    = true;
            $scope.listTabModel.disableAddBtn = true;
            $scope.divTags = "";
            var existingTag       = $scope.listTabModel.existingTag;
            var processing        = $scope.listTabModel.processing;
            var listName          = $scope.listTabModel.listName;
            var idList            = $scope.listTabModel.idList;
            var listTagObjectType = $scope.listTabModel.listTagObjectType;
            var linkedObjectType = $scope.listTabModel.linkedObjectType;

            if (processing == '0' && listName.trim().length > 0) {
                $scope.listTabModel.processing = 1;
                var data = 'idList=' + idList + '&objectType=' + listTagObjectType + '&linkedObjectType=' + linkedObjectType + '&forCallList=true';
                data = data + '&tagName=' + listName.trim();

                var ajaxUrl = WEBAPP_PATH + "/listTag/addListTagCheck";
                ajaxCallList(ajaxUrl , data);
            }
            return false;
        }

        $scope.fnAppendListTagNg = function($event) {
            $event.preventDefault();

            $scope.listTabModel.showLoader    = true;
            $scope.listTabModel.disableAddBtn = true;
            $scope.divTags = "";
            var existingTag       = $scope.listTabModel.tagSelected;
            var processing        = $scope.listTabModel.processing;
            var idList            = $scope.listTabModel.idList;
            var listTagObjectType = $scope.listTabModel.listTagObjectType;
            var linkedObjectType = $scope.listTabModel.linkedObjectType;
            if (processing == '0' && existingTag) {
                $scope.listTabModel.processing = 1;
                var data = 'idList=' + idList + '&objectType=' + listTagObjectType + '&linkedObjectType=' + linkedObjectType + '&forCallList=true';
                data = data + '&existingTag=' + existingTag;
                var ajaxUrl = WEBAPP_PATH + "/listTag/appendListTag";
                ajaxCallList(ajaxUrl , data);
            }
            return false;
        }

        $scope.fnOverwriteListTagNg = function($event) {
            $event.preventDefault();
            $scope.listTabModel.showLoader = true;
            $scope.listTabModel.disableAddBtn = true;
            $scope.divTags = "";
            var existingTag = $scope.listTabModel.tagSelected;
            var processing = $scope.listTabModel.processing;
            var idList = $scope.listTabModel.idList;
            var listTagObjectType = $scope.listTabModel.listTagObjectType;
            var linkedObjectType = $scope.listTabModel.linkedObjectType;
            if (processing == '0' && existingTag) {
                $scope.listTabModel.processing = 1;
                var data = 'idList=' + idList + '&objectType=' + listTagObjectType + '&linkedObjectType=' + linkedObjectType + '&forCallList=true';
                data = data + '&existingTag=' + existingTag;

                var ajaxUrl = WEBAPP_PATH + "/listTag/overwriteListTag";
                ajaxCallList(ajaxUrl , data);
            }
            return false;
        }

        $scope.fnRemoveFromListNg = function($event) {
            $event.preventDefault();
            $scope.listTabModel.showLoader = true;
            $scope.listTabModel.disableRemoveBtn = true;
            var matchingList = $scope.listTabModel.matchingList;
            var processing = $scope.listTabModel.processing;
            var idList = $scope.listTabModel.idList;
            var listTagObjectType = $scope.listTabModel.listTagObjectType;
            if (processing == '0' && matchingList) {
                $scope.listTabModel.processing = 1;
                var data = 'idList=' + idList + '&objectType=' + listTagObjectType + '&forCallList=true';
                data = data + '&tagName=' + matchingList;

                var ajaxUrl = WEBAPP_PATH + "/listTag/removeFromListTag";
                ajaxCallList(ajaxUrl , data);
            }
            return false;
        }

        $scope.cancelPop = function($event) {
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
        }

        /*$scope.compileElementModal = function(el) {
            $compile(el)($scope);
        }*/
        // End For List Tag

    }



    CallListCtrl.$inject = ['$scope', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance', 'params','$http', '$compile', '$window', '$sce'];
    angular.module('app').controller('CallListCtrl', CallListCtrl);


}());
